export default [{
    path: 'department',
    component: () => import('@/views/organization/department/department.main'),
    children: [{
        path: 'list',
        components: {
            list: () => import('@/views/organization/department/department.list'),
        },
    }, {
        path: 'detail',
        components: {
            detail: () => import('@/views/organization/department/department.detail'),
        },
    }]
}]